module.exports = __webpack_public_path__ + "static/media/11.85dd09d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/11.svg
// module id = 123
// module chunks = 0